import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { DataPackLine } from '../../app/models/dataPackLine.model';
import { GlobalVariable } from '../../app/app.global';
import { DataPackLineAcount } from '../models/dataPackLineAcount.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ModalTimeOut } from '../home/paraEmpresas/modaltimeout/content.component';
import { CommonService } from '../../app/services/common.service';
import { BindComponentService } from '../utils/bind.component.service';
import { ReportDownloadService } from './report.download.service';
import { DataPackGroup } from '../models/start';
/**
 * @version $Id: block.group.service.ts 91275 2018-05-15 20:41:25Z eduardo.s.neto $
 */
@Injectable()
export class BlockGroupService extends CommonService {


  private localURL: string;

  private BLOCK_PATH: string = '/datapackblockgroup';

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService, public reportDownloadService: ReportDownloadService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.BLOCK_PATH;
  }

  public loadView(startRow: number, fetchSize: number, filter?: string) {
    let url = this.localURL + '?action=loadView';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    if(typeof filter === 'undefined') {
      url += '&filter=all_lines';
    } else {
      url += '&filter=' + filter;
    } 
    
    return this.convertResponse(this.httpGet(url));
  }

  public loadViewBlockVoice(startRow: number, fetchSize: number) {
     return this.convertResponse(this.httpPost(this.localURL,{action:'loadViewBlockVoice',startRow:startRow,fetchSize:fetchSize}));
  }

  
  public listGroups(startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=listGroups';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public listGroupsBlockVoice(startRow: number, fetchSize: number) {
    return this.convertResponse(this.httpPost(this.localURL, {startRow:startRow,fetchSize:fetchSize}));
  }



  public listLines(group: DataPackGroup, startRow: number, fetchSize: number, filter?: string) {
    let url = this.localURL + '?action=listLines'
    if(group) {
      url += '&groupId=' + group.id;
    }
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    if(typeof filter === 'undefined') {
      url += '&filter=all_lines';
    } else {
      url += '&filter=' + filter;
    }    

    return this.convertResponse(this.httpGet(url));;
  }

  public blockLines(payload: any) {
    return this.convertResponse(this.httpPost(this.localURL + '?action=blockLines', payload));
  }

  public unblockLines(payload: any) {
    return this.convertResponse(this.httpPost(this.localURL + '?action=unBlockLines', payload));
  }

  public getLineData(lineAcountList: any) {
    return this.convertResponse(this.httpPost(this.localURL , {lineAcountList ,action:'getLineData'}))
  }

  public getGroupData(groupId: any) {
    return this.convertResponse(this.httpPost(this.localURL , {groupId ,action:'getGroupData'}))
  }

  public saveLockVoice(dataPackLineAcount: DataPackLineAcount) {
    return this.convertResponse(this.httpPost(this.localURL , { dataPackLineAcount ,action:'saveLockVoice'}))
  }

  public saveblockGroupVoice(group: DataPackGroup) {
    return this.convertResponse(this.httpPost(this.localURL , { group:group ,action:'saveBlockGroupVoice'}))
  }

  public configSMS(option: any, list:any) {
    return this.convertResponse(this.httpPost(this.localURL, { serviceCode:'BLKCORP_SMS' ,action:'blockLines',optionBlocked:option,listLinesBlocked:list}));
  }
  
  public configManager(option: any, list:any) {
	return this.convertResponse(this.httpPost(this.localURL, { serviceCode:'BLKCORP_MANAGER' ,action:'blockLines',optionBlocked:option,listLinesBlocked:list}));
  }


  public loadingLines(group:DataPackGroup,startRow: number, fetchSize: number) {
    return this.convertResponse(this.httpPost(this.localURL,{group:group,action:'loadLinesBlockVoice',startRow:startRow,fetchSize:fetchSize}));
  }

  public loadGroupFilterVoice(group:DataPackGroup,startRow: number, fetchSize: number) {
    return this.loadGroupFilter(group, startRow, fetchSize, false);
  }

  public loadGroupFilterData(group:DataPackGroup,startRow: number, fetchSize: number) {
    return this.loadGroupFilter(group, startRow, fetchSize, true);
  }

  public loadGroupFilter(group:DataPackGroup,startRow: number, fetchSize: number, dataContext: boolean) {
    return this.convertResponse(this.httpPost(this.localURL,{group:group,action:'loadSelectedLineAndGroup',startRow:startRow,fetchSize:fetchSize,dataContext:dataContext}));
  }

  public generateReport(groupId: string) {
    let url = this.localURL + '?action=reportBlockStatus';
    url += '&groupId=' + groupId;

   this.reportDownloadService.prepare(url);
  }

  public releaseLines(payload: any) {
    return this.convertResponse(this.httpPost(this.localURL + '?action=releaseLines', payload));
  }

  public unReleaseLines(payload: any) {
    return this.convertResponse(this.httpPost(this.localURL + '?action=unReleaseLines', payload));
  }

  public loadingLinesNow(group: DataPackGroup, serviceType: string, startRow: number, fetchSize: number) {
      return this.convertResponse(this.httpPost(this.localURL, { group: group, action: 'loadLinesBlockVoice', filterValue: serviceType, startRow: startRow, fetchSize: fetchSize }));
  }

  public loadViewBlockVoiceNow(serviceType: string, startRow: number, fetchSize: number) {
      return this.convertResponse(this.httpPost(this.localURL, { action: 'loadViewBlockVoice', serviceType: serviceType, startRow: startRow, fetchSize: fetchSize }));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/block.group.service.ts